import panzoom from 'panzoom';
import { _breakP } from './utils.js';

export default class ZoomFigure {
  constructor() {
    this.zoomFunc();
  }

  zoomFunc() {
    const containers = document.querySelectorAll('.js-zoomFigure');
    if (!containers.length) return;

    containers.forEach((elm) => {
      const mode = elm.dataset.mode;
      const target = elm.querySelector('.zoomFigure__scene');
      const plusBtn = elm.querySelector('.zoomFigure__btn--zoomIn');
      const minusBtn = elm.querySelector('.zoomFigure__btn--zoomOut');
      if (!target || !plusBtn || !minusBtn) return;

      const initZoom = () => {
        const panzoomInstance = panzoom(target, {
          bounds: true,
          boundsPadding: 1,
          maxZoom: 3,
          minZoom: 1,
          beforeWheel: (e) => !e.altKey
        });
        plusBtn.addEventListener('click', () => {
          panzoomInstance.smoothZoom(0, 0, 1.5);
        });
        minusBtn.addEventListener('click', () => {
          panzoomInstance.smoothZoom(0, 0, 0.5);
        });
      };

      // mode: 'sp' | 'pc' | 'both'（PC/SP両方でズーム機能を有効にする）
      if (mode === 'pc') {
        if (!_breakP.SP) initZoom();
      } else if (mode === 'sp') {
        if (_breakP.SP) initZoom();
      } else if (mode === 'both' || !mode) {
        initZoom();
      }
    });
  }
}
